<template>
    <section class="admin">
        <Loader :loading="loader" :fixed="true"></Loader>

        <p class="admin-user-title" v-if="zone">
            {{ zone.name }} {{ currentBrandZone && currentBrandZone.zoneGroupsRights ? "(" + currentBrandZone.zoneGroupsRights.name + ")" : "" }}
        </p>

        <div class="admin-user" v-if="zone && currentBrandZone">
            <div class="admin-user-infos table-responsive">
                <table>
                    <tr>
                        <th>{{ $t("zonerole.ref") }} :</th>
                        <td>{{ zone.refClient ? zone.refClient : "-" }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t("zonerole.type") }} :</th>
                        <td>{{ currentBrandZone.zoneRelationType ? currentBrandZone.zoneRelationType.name : "-" }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t("zonerole.group") }}:</th>
                        <td>{{ currentBrandZone.zoneGroupsRights ? currentBrandZone.zoneGroupsRights.name : "-" }}</td>
                    </tr>
                </table>
            </div>

            <div class="row d-flex align-items-center mt-5" v-if="canManageZone()">
                <div class="col-12 col-sm-auto admin-user-manage">
                    <span class="">{{ $t("userAdmin.manage") }} :</span>
                </div>
                <div class="col-12 col-sm">
                    <ClientColorButton size="l" :inactive-color="true" class="mr-4" @click="openModalEditZone();">{{
                        $t("userAdmin.edit_info")
                    }}</ClientColorButton>
                    <ClientColorButton size="l" :inactive-color="true" class="mr-4" @click="openModalDisableBrandZone();">{{
                        $t("userAdmin.delete_from_brand")
                    }}</ClientColorButton>
                    <ClientColorButton v-if="isSuperAdmin()" size="l" :inactive-color="true" class="mr-4" @click="openModalDisableZone();">{{
                        $t("zonerole.disable_zone")
                    }}</ClientColorButton>
                </div>
            </div>

            <div class="row mt-5" v-if="brandZonesFiltered.length">
                <div class="col-12 col-md-auto pb-3 admin-user-access">
                    <span>{{ $t("userAdmin.access") }} :</span>
                </div>
                <div class="col-12 col-md">
                    <div class="row d-flex flex-row justify-content-center justify-content-sm-start">
                        <div
                            v-for="(brandZone, key) in brandZonesFiltered"
                            v-bind:key="key"
                            v-if="isSuperAdmin() || isClientAdmin(brandZone.brand.id)"
                            class="px-4 pb-3"
                            style="flex-basis: 250px;flex-grow: 0;"
                        >
                            <ClientColorButton background-color="#727a96" width="100%" @click="changeBrand(brandZone.brand);">
                                {{ brandZone.brand.name }}
                            </ClientColorButton>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md d-flex justify-content-end align-self-end">
                    <History :object="zone" :object-type="OBJECT_TYPE.ZONES" :is-dark="false" :is-grey="true"></History>
                </div>
            </div>

            <EditZone v-if="modalParamsEditZone" :params="modalParamsEditZone" @success="loadZone();"></EditZone>
            <DisableBrandZone v-if="modalParamsDisableBrandZone" :params="modalParamsDisableBrandZone" @success="close();"></DisableBrandZone>
            <DisableZone v-if="modalParamsDisableZone" :params="modalParamsDisableZone" @success="close();"></DisableZone>
        </div>

        <div class="admin-role mt-5" v-if="getBrandAccess && getBrandAccess.length">
            <div class="row mb-4">
                <div class="col">
                    <span class="admin-role-title">{{ $t("userrole.rights") }} :</span>
                </div>
                <div class="col-auto">
                    <ClientColorButton v-if="zoneUsersFiltered.length" :color="currentBrand.colorLinks" @click="save">{{
                        $t("common.save")
                    }}</ClientColorButton>
                </div>
            </div>

            <b-tabs content-class="mt-3">
                <b-tab
                    v-for="(brandAccess, key) in brandAccessFiltered"
                    v-bind:key="key"
                    :title="getTranslate(brandAccess.terms.name)"
                    v-if="displayTab(brandAccess.application)"
                    :active="rightsUserTab ? key === parseInt(rightsUserTab, 10) : key === 0"
                    @click="changeApp(brandAccess, key);"
                >
                    <div class="row mt-4">
                        <div class="col">
                            <input type="text" id="searchBySearch" v-model="search" class="rem3rch-input-text" />
                            <label for="searchBySearch" class="m-0 pointer ml-3"><i class="fa fa-search fa-lg color-grey"></i></label>
                        </div>
                    </div>

                    <div class="responsive-table-old">
                        <table class="admin-role-table">
                            <thead>
                                <tr>
                                    <th colspan="4">
                                        <div class="row d-flex align-items-center">
                                            <div class="col-auto">
                                                <ClientColorButton class="mt-4" :inactive-color="true" @click="selectAll();">{{
                                                    $t("common.selectAll")
                                                }}</ClientColorButton>
                                            </div>
                                            <div class="col-auto">
                                                <ClientColorButton class="mt-4" :inactive-color="true" @click="selectNone();">{{
                                                    $t("common.selectNone")
                                                }}</ClientColorButton>
                                            </div>
                                            <div class="col-auto">
                                                <ClientColorButton class="mt-4" :inactive-color="true" @click="resetSelectedProfiles();">{{
                                                    $t("common.resetSelection")
                                                }}</ClientColorButton>
                                            </div>
                                            <div class="col-auto admin-role-filter mt-4">
                                                <Multiselect
                                                    v-model="filteredProfile"
                                                    :options="profiles"
                                                    :label="'name'"
                                                    track-by="name"
                                                    :multiple="false"
                                                    :select-label="''"
                                                    :searchable="false"
                                                    :close-on-select="true"
                                                    :show-labels="true"
                                                    :placeholder="$t('zonerole.filterProfile')"
                                                    :deselect-label="$t('common.delete')"
                                                />
                                            </div>
                                        </div>
                                    </th>
                                    <th class="header-profile admin-role-filter mt-4">
                                        <Multiselect
                                            v-if="checkedUsers.length > 0"
                                            v-model="multiProfileUpdate"
                                            :options="profilesFiltered"
                                            :label="'name'"
                                            track-by="name"
                                            :multiple="false"
                                            :select-label="''"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="true"
                                            :placeholder="$t('zonerole.selectProfile')"
                                            :deselect-label="$t('common.delete')"
                                            @input="updateCheckedUsersProfile(multiProfileUpdate);"
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, key) in zoneUsersFiltered" v-bind:key="key">
                                    <td class="color" :style="{ backgroundColor: getProfileColor(user.id) }"></td>
                                    <td class="checkbox">
                                        <template v-if="profileCanBeUpdated(seletedProfileByUser[user.id])">
                                            <label
                                                :for="'checkbox_user_' + user.id"
                                                class="label-checkbox pointer mb-0 d-flex align-items-center justify-content-center"
                                            >
                                                <span
                                                    v-show="checkedUsers.includes(user.id)"
                                                    @click="checkUser(user.id, false);"
                                                    class="rem3rch-checkbox rem3rch-checkbox"
                                                >
                                                    <i class="fa fa-check"></i>
                                                </span>
                                                <span
                                                    v-if="!checkedUsers.includes(user.id)"
                                                    @click="checkUser(user.id, true);"
                                                    class="rem3rch-checkbox rem3rch-checkbox"
                                                ></span>
                                            </label>
                                        </template>
                                    </td>
                                    <td class="id">
                                        <span>{{ user.id }}</span>
                                    </td>
                                    <td class="name">
                                        <span>{{ user.firstname.toLowerCase() + " " }}</span> <span>{{ user.lastname.toLowerCase() }}</span>
                                    </td>
                                    <td class="profile">
                                        <Multiselect
                                            v-model="seletedProfileByUser[user.id]"
                                            :options="profilesFiltered"
                                            :label="'name'"
                                            track-by="name"
                                            :multiple="false"
                                            :select-label="''"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="true"
                                            :placeholder="$t('userrole.selectProfile')"
                                            :deselect-label="$t('common.delete')"
                                            :disabled="!profileCanBeUpdated(seletedProfileByUser[user.id])"
                                        />
                                    </td>
                                    <td class="view-zone text-center">
                                        <ClientColorButton @click="$router.push({ path: '/users/user/' + user.id });" :inactive-color="true">{{
                                            $t("zonerole.viewUser")
                                        }}</ClientColorButton>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="!zoneUsersFiltered.length" class="d-flex align-items-center justify-content-center notfound">
                            <span>{{ $t("userrole.notfound") }}</span>
                        </div>
                    </div>
                </b-tab>
                <div class="d-flex justify-content-center mt-4">
                    <ClientColorButton :inactive-color="true" @click="close" class="mr-3">{{ $t("common.cancel") }}</ClientColorButton>
                    <ClientColorButton v-if="zoneUsersFiltered.length" :color="currentBrand.colorLinks" @click="save">{{
                        $t("common.save")
                    }}</ClientColorButton>
                </div>
            </b-tabs>
        </div>
    </section>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import http from "../../service";
import Spinner from "vue-simple-spinner";
import cacheService from "@/services/cache";
import userService from "@/services/user";
import AppSection from "@/components/admin/user/AppSection";
import CheckBoxModal from "@/components/common/CheckBoxModal";
import Multiselect from "vue-multiselect";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import historyService from "@/services/history";
import Loader from "@/components/loader/loader";
import currentBrand from "@/services/currentBrand";
import History from "@/components/history/History";
import { APPLICATION } from "@/components/admin/brand/constant";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import DeleteBrand from "@/components/users/actions/DeleteBrand";
import ChangeAccess from "@/components/users/actions/ChangeAccess";
import zoneService from "@/services/zone";
import EditZone from "@/components/admin/zone/EditZone";
import DisableBrandZone from "@/components/admin/zone/DisableBrandZone";
import DisableZone from "@/components/admin/zone/DisableZone";
import { FUNCTIONALITY } from "@/components/tools/constants";

const d3 = require("d3"); // eslint-disable-line no-unused-vars

export default {
    components: {
        DisableZone,
        DisableBrandZone,
        ChangeAccess,
        DeleteBrand,
        History,
        Loader,
        Spinner,
        AppSection,
        CheckBoxModal,
        Multiselect,
        EditZone
    },
    props: ["checkedOption"],
    data() {
        return {
            FUNCTIONALITY,
            brands: cacheService.getBrands(),
            access: null,
            checkedUsers: [],
            seletedProfileByUser: [],
            tmpSeletedProfileByUser: [],
            profiles: [],
            superadmin: false,
            loader: true,
            accessApplication: [],
            isCheckBoxModalVisible: false,
            search: "",
            currentApp: null,
            OBJECT_TYPE,
            filteredProfile: null,
            filteredGroup: null,
            multiProfileUpdate: null,
            rightsUserTab: localStorage.getItem("rights_tab"),
            zone: null,
            currentBrandZone: null,
            modalParamsEditZone: null,
            modalParamsDisableZone: null,
            modalParamsDisableBrandZone: null
        };
    },
    async created() {
        this.loader = true;

        await this.loadZone();

        await this.findBrandAccess(cacheService.getCurrentBrandId());

        if (this.brandAccessFiltered.length) {
            if (localStorage.getItem("rights_tab")) {
                const brandAccess = this.brandAccessFiltered[localStorage.getItem("rights_tab")];
                if (brandAccess) {
                    this.currentApp = brandAccess.application;
                } else {
                    this.currentApp = this.brandAccessFiltered[0].application;
                }
            } else {
                this.currentApp = this.brandAccessFiltered[0].application;
            }
        }

        await Promise.all([await this.findAllApplicationProfile(), await this.getAllUsersListAction({})]);

        await this.init();
        this.loader = false;
    },
    mounted() {},
    beforeDestroy() {
        this.cleanFunctionalitiesAccess();
        this.access = null;
    },
    computed: {
        ...mapGetters({
            getApplicationProfile: "user/getApplicationProfile",
            getBrandAccess: "brand/getBrandAccess",
            getAllUsersList: "user/getAllUsersList"
        }),
        ...mapGetters("currentUser", ["currentProfiles"]),
        ...mapState("currentUser", ["currentBrand"]),
        zoneUsersFiltered() {
            const checkedUsers = [];
            const zoneUsers = this.getAllUsersList
                .filter(u => u.isEnabled)
                .filter(u => u.userBrand.some(ub => ub.brand.id === this.currentBrand.id))
                .filter(
                    u =>
                        this.search === "" ||
                        u.id.toString().indexOf(this.search) > -1 ||
                        u.firstname.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                        u.lastname.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                )
                .filter(u => {
                    const userProfile = this.seletedProfileByUser ? this.seletedProfileByUser[u.id] : null;
                    if (this.filteredProfile) {
                        if (userProfile) {
                            return userProfile.name === this.filteredProfile.name;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                });
            zoneUsers.forEach(u => {
                this.checkedUsers.forEach(userId => {
                    if (u.id === userId) {
                        checkedUsers.push(userId);
                    }
                });
            });
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.checkedUsers = checkedUsers;
            return zoneUsers;
        },
        brandAccessFiltered() {
            const brandAccess = this.getBrandAccess.filter(
                ba => ba.application === APPLICATION.FORECAST_ID || ba.application === APPLICATION.CATALOG_FORECAST_ID
            );

            return brandAccess.sort((a, b) => (a.application > b.application ? 1 : b.application > a.application ? -1 : 0));
        },
        brandZonesFiltered() {
            if (!this.zone || !this.zone.brandZone) {
                return [];
            }
            return this.zone.brandZone.filter(bz => bz.brand.id !== this.currentBrand.id);
        },
        profilesFiltered() {
            const profiles = [];
            if (!this.isSuperAdmin() && !this.isClientAdmin()) {
                const currentProfile = this.currentProfiles.find(p => p.id === this.currentApp);
                if (currentProfile) {
                    const appProfile = this.getApplicationProfile.find(ap => ap.profile.name === currentProfile.profileName);
                    if (appProfile) {
                        this.getApplicationProfile.forEach(ap => {
                            if (ap.application.id === this.currentApp && ap.level < appProfile.level) {
                                profiles.push(ap.profile);
                            }
                        });
                    }
                }
            } else {
                this.getApplicationProfile.forEach(ap => {
                    if (ap.application.id === this.currentApp) {
                        profiles.push(ap.profile);
                    }
                });
            }
            return profiles;
        }
    },
    methods: {
        ...mapActions({ setZone: "items/setZone" }),
        ...mapActions({
            findBrandAccess: "brand/findBrandAccess",
            getAllUsersListAction: "user/getAllUsersListAction",
            cleanFunctionalitiesAccess: "user/cleanFunctionalitiesAccess",
            findAllApplicationProfile: "user/findAllApplicationProfile"
        }),
        ...mapActions("brand/", ["populate"]),
        ...mapActions("currentUser/", ["populateInfo"]),
        async loadZone() {
            this.zone = await zoneService.getZone(this.$route.params.id);
            this.currentBrandZone = this.zone.brandZone.find(bz => bz.brand.id === cacheService.getCurrentBrandId());
            if (!this.zone.active) {
                this.$router.push({ path: "/zones/zone-list" });
            }
        },
        async changeBrand(brand) {
            const fullBrand = this.brands.find(b => b.id === brand.id);
            await currentBrand.save(fullBrand, null, this.$accessUser);
            this.populate();
            this.populateInfo();
            location.reload();
        },
        async changeApp(brandAccess, key) {
            this.loader = true;
            this.currentApp = brandAccess.application;
            this.selectNone();
            await this.init();
            localStorage.setItem("rights_tab", key.toString());
            this.loader = false;
        },
        getProfileColor(zoneId) {
            const profile = this.seletedProfileByUser ? this.seletedProfileByUser[zoneId] : null;
            if (profile) {
                switch (profile.name) {
                    case PROFILES.FORECAST_MANAGER:
                        return "#faa4a4";
                    case PROFILES.ZONE_READER:
                        return "#a7f0fa";
                    case PROFILES.ZONE_FORECASTER:
                        return "#ca9bfc";
                    case PROFILES.ZONES_SUPERVISOR:
                        return "#a4fab1";
                    case PROFILES.COORDINATOR:
                        return "#fae9a4";
                }
            }
            return null;
        },
        selectAll() {
            this.zoneUsersFiltered.forEach(u => {
                if (!this.checkedUsers.includes(u.id)) {
                    this.checkedUsers.push(u.id);
                }
            });
        },
        selectNone() {
            this.checkedUsers = [];
        },
        checkUser(userId, add) {
            if (add) {
                this.checkedUsers.push(userId);
            } else {
                this.checkedUsers.splice(this.checkedUsers.indexOf(userId), 1);
            }
        },
        resetSelectedProfiles() {
            const selectProfile = this.$t("userrole.selectProfile");
            this.checkedUsers.forEach(userId => {
                if ((!this.seletedProfileByUser[userId] || this.seletedProfileByUser[userId]) && this.tmpSeletedProfileByUser[userId]) {
                    this.seletedProfileByUser[userId] = Object.assign({}, this.tmpSeletedProfileByUser[userId]);
                }
                if (this.seletedProfileByUser[userId] && !this.tmpSeletedProfileByUser[userId]) {
                    this.seletedProfileByUser[userId] = { name: selectProfile };
                }
            });
        },
        updateCheckedUsersProfile(profile) {
            this.checkedUsers.forEach(userId => {
                this.seletedProfileByUser[userId] = profile;
            });
            this.selectNone();
        },
        profileCanBeUpdated(profile) {
            if (!this.profilesFiltered || (this.profilesFiltered && !this.profilesFiltered.length)) {
                return false;
            }
            if (!profile || (profile && !profile.id)) {
                return true;
            }
            return this.profilesFiltered.some(p => p.id === profile.id);
        },
        save() {
            this.loader = true;

            const profiles = Object.keys(this.seletedProfileByUser)
                .filter(index => this.zoneUsersFiltered.some(u => u.id == index))
                .map(index => {
                    return { user: index, zone: this.zone, profile: this.seletedProfileByUser[index] };
                });

            http.put("/admin/profiles/zone", JSON.stringify({ profiles, application: this.currentApp })).then(resp => {
                if (resp.code) {
                    this.loader = false;
                    this.dialogError(resp.message);
                } else {
                    this.loader = false;
                    this.tmpSeletedProfileByUser = Object.assign({}, this.seletedProfileByUser);
                    this.dialogSuccess(SHORT_DESCRIPTION.USE);
                }
            });
        },
        close() {
            this.$router.push({ path: "/zones/zone-list" });
        },
        async init() {
            this.profiles = await userService.getProfiles();

            const spz = [];
            this.zoneUsersFiltered.forEach(u => {
                const ua = this.zone.users.find(ua => ua.id === u.id && ua.appId === this.currentApp);

                if (ua) {
                    spz[u.id] = { id: ua.profileId, name: ua.profileName };
                } else {
                    spz[u.id] = { name: this.$t("userrole.selectProfile") };
                }
            });
            this.seletedProfileByUser = Object.assign({}, spz);
            this.tmpSeletedProfileByUser = Object.assign({}, spz);
        },
        openModalEditZone() {
            this.setZone(this.zone);
            this.modalParamsEditZone = {
                isActive: true
            };
        },
        openModalDisableBrandZone() {
            this.modalParamsDisableBrandZone = {
                zone: this.zone,
                brandZone: this.currentBrandZone,
                isActive: true
            };
        },
        openModalDisableZone() {
            this.modalParamsDisableZone = {
                zone: this.zone,
                isActive: true
            };
        },
        displayTab(appId) {
            return this.isClientAdmin() || this.isSuperAdmin() || this.hasAccessUpdate(FUNCTIONALITY.ZONE, [appId]);
        },
        canManageZone() {
            return this.isSuperAdmin() || this.isClientAdmin();
        }
    }
};
</script>

<style lang="scss" scoped>
.admin {
    color: #6f6f6f;
    width: 100%;
    padding: 30px;
    background-color: #fff;
    &-user {
        width: 100%;
        padding: 20px;
        background-color: #f4f4f4;
        &-title {
            font-size: 28px;
            color: #6f6f6f;
            text-transform: uppercase;
            font-family: "Oswald", sans-serif;
        }
        &-manage,
        &-access {
            min-width: 120px;
            span {
                font-size: 24px;
                font-family: "Oswald", sans-serif;
            }
        }
        &-infos {
            table {
                th {
                    white-space: nowrap;
                    vertical-align: baseline;
                    text-transform: uppercase;
                    font-size: 22px;
                    font-weight: normal;
                    font-family: "Oswald", sans-serif;
                }
                td {
                    white-space: nowrap;
                    vertical-align: baseline;
                    font-size: 18px;
                    padding-left: 15px;
                }
            }
        }
    }

    &-role {
        width: 100%;
        &-title {
            font-size: 24px;
            font-family: "Oswald", sans-serif;
        }
        &-switch-client-admin {
            span {
                text-transform: initial;
                font-size: 18px;
            }
        }
        &-table {
            width: 100%;
            th {
                vertical-align: bottom;
                &.header-profile {
                    padding: 5px 10px;
                    width: 350px;
                }
                padding-bottom: 15px !important;
            }
            td {
                padding: 5px 10px;
                background-color: #f4f4f4;
                border-bottom: 5px solid #fff;
                &.color {
                    width: 20px;
                    padding: 5px;
                }
                &.id,
                &.name {
                    span {
                        color: #111;
                        font-size: 20px;
                        font-family: "Oswald", sans-serif;
                        text-transform: capitalize;
                        @media (max-width: 1440px) {
                            font-size: 18px;
                        }
                    }
                }
                &.profile {
                    width: 350px;
                }
                &.view-zone {
                    width: 200px;
                }
            }
        }
    }
    .notfound {
        height: 150px;
        border: #6f6f6f 1px solid;
        span {
            font-size: 16px;
            text-transform: initial;
        }
    }
}
</style>

<style lang="scss">
.admin {
    &-role {
        .nav-tabs {
            .nav-item {
                a {
                    position: relative;
                    color: #111;
                    font-size: 18px;
                    font-weight: normal;
                    text-transform: uppercase;
                    border: #6f6f6f solid 2px;
                    border-bottom: none;
                    background-color: #e9ecef;
                    &.active {
                        background-color: #fff;
                        &:before {
                            content: "";
                            position: absolute;
                            width: 100%;
                            background-color: #fff;
                            left: 0;
                            bottom: -2px;
                            height: 2px;
                        }
                    }
                }
                &:not(:first-child) {
                    a {
                        border-left: none;
                    }
                }
            }
        }
        .tab-content {
            padding: 20px;
            margin: 0 !important;
            border: #6f6f6f solid 2px;
        }

        &-filter {
            .multiselect {
                min-width: 250px;

                .multiselect__single {
                    text-align: center;
                }

                .multiselect__element {
                    text-align: center;
                }

                .multiselect__tags {
                    cursor: pointer;
                }

                .multiselect__option {
                    &.multiselect__option--selected {
                        &.multiselect__option--highlight {
                            text-align: left;
                        }

                        &:not(.multiselect__option--highlight) {
                            &:after {
                                display: none;
                            }
                        }
                    }
                }
            }
        }

        td.profile {
            .multiselect__tags {
                cursor: pointer;
                background-color: #fff !important;
                .multiselect__single {
                    background-color: #fff !important;
                }
                .multiselect__single {
                    text-align: center;
                }
            }
            .multiselect__element {
                text-align: center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// ZoneRole.vue?eff61688